import React from 'react';
import { isFunction, omit, } from 'lodash';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';
import { useToggle, } from 'react-use';
import classnames from 'classnames';

export default function AddButton ({ initialValues, validateOnSubmit = _ => true, itemRef, FormModal, formProps, processValues = _ => _, label = '追加', iconClassName = 'fas fa-plus', beforeSave, onFinish, opensInitially, ...extraProps }) {
  const [showsModal, toggleModal] = useToggle(opensInitially);
  const onSubmit = async (values) => {
    const ref = isFunction(itemRef) ? await itemRef(values) : itemRef;
    const { id } = ref;
    if(!(await validateOnSubmit({ id, ...values }))) return;

    try {
      const beforeValues = beforeSave && await beforeSave({ id, ...values });
      if(!beforeValues?.skipDefaultSet) {
        await ref.set({ ...omit(await processValues({ id, ...values, ...beforeValues, }), ['id', 'ref']), createdAt: new Date(), });
      }
      onFinish && await onFinish({ id, ref, ...values });
      toast.success('追加しました');
      toggleModal(false);
    } catch(e) {
      console.error(e);
      toast.error(e.message || '失敗しました');
    }
  };

  return (
    <Button color="primary" onClick={_ => toggleModal(true)} {...extraProps}>
      <span className={classnames(iconClassName, 'mr-1')} />
      {label}
      {showsModal && <FormModal itemRef={itemRef} isOpen values={initialValues} onClickClose={_ => toggleModal(false)} onSubmit={onSubmit} {...formProps} />}
    </Button>
  );
};
